import { useCallback } from "react";
import { useApplicationLanguage } from "melco-shared-logic";

export const useStatisticsNumberFormatter = () => {
  const language = useApplicationLanguage();

  const formatNumber = useCallback(
    (num: number, compact?: boolean): string => {
      return new Intl.NumberFormat(language, {
        notation: compact ? "compact" : "standard",
        compactDisplay: "short",
        maximumFractionDigits: 2,
      }).format(num);
    },
    [language]
  );

  return {
    formatNumber,
  };
};
